<template>
  <component :is="networkTag" :data-link="dataLink" :data-action="dataAction" @click="handleClick">
    <slot></slot>
  </component>
</template>

<script>
import Networks from '../networks.json';

export default {
  name: 'social-sharing-network',

  inject: ['networkTag', 'createSharingUrl', 'shareFn', 'touchFn'],

  props: {
    network: {
      type: String,
      default: '',
    },
  },

  computed: {
    networkConfig() {
      return Networks[this.network];
    },
    dataLink() {
      return this.networkConfig.type === 'popup'
        ? '#share-' + this.network
        : this.createSharingUrl(this.network);
    },
    dataAction() {
      return this.networkConfig.type === 'popup' ? null : this.networkConfig.action;
    },
  },

  methods: {
    handleClick() {
      if (this.networkConfig.type === 'popup') {
        this.shareFn(this.network);
      } else {
        this.touchFn(this.network);
      }
    },
  },
};
</script>
